import SvgIcon from '../layout/svg-icons/svg-icons'
import Image from 'next/image'

export const server_name = `${
  process.env.NEXT_PUBLIC_PROFILE_TIP_SERVER_IP
    ? process.env.NEXT_PUBLIC_PROFILE_TIP_SERVER_IP
    : 'https://form.canarymission.org'
}`

export const getPhotoSizeString = (photo: File) => {
  const size = photo.size / (1024 * 1024)
  return `${size.toFixed(2)}MB`
}

export const sanitizeString = (str: string | undefined | null) => {
  if (str !== null && str !== undefined) {
    return str.replace(/[<>{}()[\]?\/\\|]/g, '_')
  } else return ''
}

export const supportedImgTypes = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/gif',
  'image/pdf',
  'video/mp4',
  'video/quicktime',
]

export const addIcon = (
  <SvgIcon width="17" height="17" viewBox="0 0 17 17" fill="none">
    <path
      d="M13.9706 13.9706C12.8517 15.0894 11.4263 15.8513 9.87443 16.16C8.32258 16.4687 6.71405 16.3103 5.25224 15.7048C3.79044 15.0993 2.54101 14.0739 1.66196 12.7583C0.782905 11.4427 0.313713 9.89597 0.313713 8.31372C0.313713 6.73147 0.782905 5.18475 1.66196 3.86916C2.54101 2.55357 3.79044 1.52819 5.25224 0.922686C6.71405 0.317185 8.32258 0.158759 9.87443 0.467441C11.4263 0.776123 12.8517 1.53805 13.9706 2.65687C15.4687 4.1583 16.3101 6.1927 16.3101 8.31372C16.3101 10.4347 15.4687 12.4691 13.9706 13.9706ZM3.78823 3.78824C2.89317 4.68329 2.28363 5.82367 2.03669 7.06514C1.78974 8.30662 1.91648 9.59345 2.40088 10.7629C2.88528 11.9323 3.70559 12.9319 4.75806 13.6351C5.81054 14.3384 7.04791 14.7137 8.31371 14.7137C9.57951 14.7137 10.8169 14.3384 11.8694 13.6351C12.9218 12.9319 13.7421 11.9323 14.2265 10.7629C14.7109 9.59345 14.8377 8.30662 14.5907 7.06514C14.3438 5.82367 13.7342 4.6833 12.8392 3.78824C11.638 2.58977 10.0105 1.9167 8.31371 1.9167C6.61691 1.9167 4.9894 2.58977 3.78823 3.78824Z"
      fill="currentColor"
    />
    <path
      d="M9.11359 7.51384V4.91961C9.10994 4.70987 9.02407 4.50996 8.87446 4.36293C8.72485 4.2159 8.52348 4.13351 8.31371 4.13351C8.10395 4.13351 7.90257 4.2159 7.75296 4.36293C7.60335 4.50996 7.51748 4.70987 7.51383 4.91961L7.51383 7.51384H4.9196C4.70987 7.51749 4.50995 7.60336 4.36292 7.75297C4.21589 7.90258 4.1335 8.10396 4.1335 8.31372C4.1335 8.52349 4.21589 8.72486 4.36292 8.87447C4.50995 9.02408 4.70987 9.10995 4.9196 9.1136L7.51383 9.1136V11.7078C7.51199 11.814 7.53131 11.9196 7.57068 12.0182C7.61005 12.1169 7.66867 12.2067 7.74313 12.2825C7.81759 12.3582 7.90639 12.4184 8.00436 12.4595C8.10232 12.5006 8.20748 12.5217 8.31371 12.5217C8.41994 12.5217 8.5251 12.5006 8.62307 12.4595C8.72103 12.4184 8.80983 12.3582 8.88429 12.2825C8.95875 12.2067 9.01737 12.1169 9.05674 12.0182C9.09611 11.9196 9.11544 11.814 9.11359 11.7078L9.11359 9.1136H11.7078C11.9176 9.10995 12.1175 9.02408 12.2645 8.87447C12.4115 8.72486 12.4939 8.52349 12.4939 8.31372C12.4939 8.10395 12.4115 7.90258 12.2645 7.75297C12.1175 7.60336 11.9176 7.51749 11.7078 7.51384L9.11359 7.51384Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export const trash = (
  <SvgIcon width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M18.1488 4.21053H14.0747V2.10526C14.0747 1.54691 13.8601 1.01143 13.4781 0.616617C13.0961 0.221804 12.5779 0 12.0377 0H7.96361C7.42336 0 6.90523 0.221804 6.52321 0.616617C6.14119 1.01143 5.92658 1.54691 5.92658 2.10526V4.21053H1.8525C1.58237 4.21053 1.32331 4.32143 1.1323 4.51884C0.941292 4.71624 0.833984 4.98398 0.833984 5.26316C0.833984 5.54233 0.941292 5.81007 1.1323 6.00748C1.32331 6.20489 1.58237 6.31579 1.8525 6.31579H2.87102V17.8947C2.87102 18.4531 3.08564 18.9886 3.46766 19.3834C3.84967 19.7782 4.3678 20 4.90806 20H15.0932C15.6335 20 16.1516 19.7782 16.5336 19.3834C16.9157 18.9886 17.1303 18.4531 17.1303 17.8947V6.31579H18.1488C18.4189 6.31579 18.678 6.20489 18.869 6.00748C19.06 5.81007 19.1673 5.54233 19.1673 5.26316C19.1673 4.98398 19.06 4.71624 18.869 4.51884C18.678 4.32143 18.4189 4.21053 18.1488 4.21053ZM7.96361 2.10526H12.0377V4.21053H7.96361V2.10526ZM15.0932 17.8947H4.90806V6.31579H15.0932V17.8947Z"
      fill="#C13D20"
    />
    <path
      d="M7.96361 7.36842C7.69349 7.36842 7.43442 7.47932 7.24341 7.67673C7.0524 7.87414 6.9451 8.14188 6.9451 8.42105V15.7895C6.9451 16.0686 7.0524 16.3364 7.24341 16.5338C7.43442 16.7312 7.69349 16.8421 7.96361 16.8421C8.23374 16.8421 8.49281 16.7312 8.68382 16.5338C8.87482 16.3364 8.98213 16.0686 8.98213 15.7895V8.42105C8.98213 8.14188 8.87482 7.87414 8.68382 7.67673C8.49281 7.47932 8.23374 7.36842 7.96361 7.36842Z"
      fill="#C13D20"
    />
    <path
      d="M12.0377 7.36842C11.7676 7.36842 11.5085 7.47932 11.3175 7.67673C11.1265 7.87414 11.0192 8.14188 11.0192 8.42105V15.7895C11.0192 16.0686 11.1265 16.3364 11.3175 16.5338C11.5085 16.7312 11.7676 16.8421 12.0377 16.8421C12.3078 16.8421 12.5669 16.7312 12.7579 16.5338C12.9489 16.3364 13.0562 16.0686 13.0562 15.7895V8.42105C13.0562 8.14188 12.9489 7.87414 12.7579 7.67673C12.5669 7.47932 12.3078 7.36842 12.0377 7.36842Z"
      fill="#C13D20"
    />
  </SvgIcon>
)

export const fileIcon = (
  <SvgIcon width="29" height="29" viewBox="0 0 29 29" fill="none">
    <path
      d="M23.6615 0H11.2187C10.0089 0 8.87003 0.4524 8.01513 1.27455L3.74367 5.37515C2.88727 6.19585 2.41602 7.28915 2.41602 8.45205V26.1C2.41602 27.6994 3.72555 29 5.33716 29H23.663C25.2732 29 26.5827 27.6994 26.5827 26.1V2.9C26.5827 1.30065 25.2732 0 23.6615 0ZM9.9681 3.5003V7.25H6.06216L9.9681 3.5003ZM23.5618 26.1H5.43685V10.15H9.9681C11.6341 10.15 12.9889 8.84935 12.9889 7.25V2.9H23.5618V26.1Z"
      fill="#4B5563"
    />
    <path
      d="M10.8713 14.5566L6.88836 22.5765C6.66482 23.026 6.69654 23.5538 6.97445 23.9743C7.25086 24.3948 7.73419 24.65 8.25076 24.65H20.3341C20.8658 24.65 21.3566 24.3832 21.6285 23.9468C21.9004 23.5103 21.9155 22.968 21.6663 22.5185L18.8992 17.5334C18.6364 17.0622 18.1274 16.7678 17.5715 16.7649C16.9417 16.762 16.5037 17.0534 16.2378 17.5218L15.4207 18.9675L13.6354 14.645C13.4149 14.1085 12.8832 13.7489 12.2821 13.7301C11.6447 13.7141 11.1296 14.036 10.8713 14.5566Z"
      fill="#4B5563"
    />
    <path
      d="M18.2754 13.05C19.5267 13.05 20.541 12.0762 20.541 10.875C20.541 9.67378 19.5267 8.7 18.2754 8.7C17.0241 8.7 16.0098 9.67378 16.0098 10.875C16.0098 12.0762 17.0241 13.05 18.2754 13.05Z"
      fill="#4B5563"
    />
  </SvgIcon>
)

export const videoIcon = (
  <SvgIcon width="29" height="29" viewBox="0 0 29 29" fill="none">
    <path
      d="M23.6615 0H11.2187C10.0089 0 8.87003 0.4524 8.01513 1.27455L3.74367 5.37515C2.88727 6.19585 2.41602 7.28915 2.41602 8.45205V26.1C2.41602 27.6994 3.72555 29 5.33716 29H23.663C25.2732 29 26.5827 27.6994 26.5827 26.1V2.9C26.5827 1.30065 25.2732 0 23.6615 0ZM9.9681 3.5003V7.25H6.06216L9.9681 3.5003ZM23.5618 26.1H5.43685V10.15H9.9681C11.6341 10.15 12.9889 8.84935 12.9889 7.25V2.9H23.5618V26.1Z"
      fill="#4B5563"
    />
    <path
      d="M9.9681 13.05C8.30211 13.05 6.94727 14.3507 6.94727 15.95V18.85C6.94727 20.4494 8.30211 21.75 9.9681 21.75H12.9889C14.6549 21.75 16.0098 20.4494 16.0098 18.85V15.95C16.0098 14.3507 14.6549 13.05 12.9889 13.05H9.9681ZM9.9681 18.85V15.95H12.9889L12.9904 18.85H9.9681Z"
      fill="#4B5563"
    />
    <path
      d="M22.0514 19.4039V15.3961C22.0514 14.3188 20.8703 13.617 19.8659 14.0998L17.5202 15.95V18.85L19.8659 20.7002C20.8703 21.1831 22.0514 20.4813 22.0514 19.4039Z"
      fill="#4B5563"
    />
  </SvgIcon>
)

export const uploadSvg = (
  <SvgIcon width="20" height="21" viewBox="0 0 20 21" fill="none">
    <path
      d="M18 12.2952H13V12.808C12.9973 13.3496 12.8536 13.8807 12.584 14.3464H18V18.4488H2V14.3464H7.416C7.14635 13.8807 7.00275 13.3496 7 12.808V12.2952H2C1.46957 12.2952 0.960859 12.5113 0.585786 12.896C0.210714 13.2807 0 13.8024 0 14.3464V18.4488C0 18.9928 0.210714 19.5145 0.585786 19.8992C0.960859 20.2839 1.46957 20.5 2 20.5H18C18.5304 20.5 19.0391 20.2839 19.4142 19.8992C19.7893 19.5145 20 18.9928 20 18.4488V14.3464C20 13.8024 19.7893 13.2807 19.4142 12.896C19.0391 12.5113 18.5304 12.2952 18 12.2952Z"
      fill="#4B5563"
    />
    <path
      d="M6.707 6.3539L9 4.0022V12.808C9 13.08 9.10536 13.3409 9.29289 13.5332C9.48043 13.7255 9.73478 13.8336 10 13.8336C10.2652 13.8336 10.5196 13.7255 10.7071 13.5332C10.8946 13.3409 11 13.08 11 12.808V4.0022L13.293 6.3539C13.4816 6.54073 13.7342 6.6441 13.9964 6.64176C14.2586 6.63943 14.5094 6.53157 14.6948 6.34141C14.8802 6.15126 14.9854 5.89402 14.9877 5.62511C14.99 5.35621 14.8892 5.09714 14.707 4.90371L10.707 0.801308C10.6141 0.705798 10.5038 0.630021 10.3823 0.578317C10.2608 0.526614 10.1305 0.5 9.999 0.5C9.86747 0.5 9.73722 0.526614 9.61573 0.578317C9.49424 0.630021 9.38389 0.705798 9.291 0.801308L5.291 4.90371C5.10349 5.09629 4.99826 5.35737 4.99844 5.62953C4.99863 5.90169 5.10423 6.16262 5.292 6.35493C5.47977 6.54724 5.73434 6.65517 5.99971 6.65498C6.26507 6.65478 6.51949 6.54648 6.707 6.3539Z"
      fill="#4B5563"
    />
    <path
      d="M15 17.4232C15.5523 17.4232 16 16.964 16 16.3976C16 15.8312 15.5523 15.372 15 15.372C14.4477 15.372 14 15.8312 14 16.3976C14 16.964 14.4477 17.4232 15 17.4232Z"
      fill="#4B5563"
    />
  </SvgIcon>
)

export const spinner = (
  <div className="flex justify-center items-center ml-1">
    <Image src={'/images/favicons/loading.gif'} alt={'loading'} width={16} height={16} />
  </div>
)
